const CustomValueEditor = ({ handleOnChange, value, fieldData }) => {
  return (
    <>
      {fieldData?.valueEditorType === "select" ? (
        <select
          className="form-control"
          value={value}
          onChange={(e) => {
            handleOnChange(e.target.value);
          }}
        >
          {fieldData.values?.map((field) => (
            <option key={field.name} value={field.name}>
              {field.label}
            </option>
          ))}
        </select>
      ) : fieldData.category === "CustomerGroup" ? (
        <label className="form-control">{fieldData?.value || 0}</label>
      ) : (
        <input
          className="form-control"
          value={value}
          onChange={(e) => {
            handleOnChange(e.target.value);
          }}
        />
      )}
    </>
  );
};
export default CustomValueEditor;
